var _rect, _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOneDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 25,
    fill: "#A0CCEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1667 18.75C33.1667 24.2803 32.0958 27.4367 30.627 29.2048C29.1966 30.9266 27.2436 31.5 25 31.5C22.6589 31.5 20.7451 31.1291 19.3526 29.5559C17.9153 27.9322 16.8333 24.8088 16.8333 18.75C16.8333 17.0436 16.8624 15.8726 17.0184 15.0297C17.1679 14.2226 17.4055 13.8767 17.7113 13.6613C18.079 13.4023 18.7202 13.205 19.9591 13.102C21.1774 13.0008 22.7948 13 25 13C27.2052 13 28.8226 13.0008 30.0409 13.102C31.2798 13.205 31.921 13.4023 32.2887 13.6613C32.5945 13.8767 32.8321 14.2225 32.9816 15.0297C33.1376 15.8726 33.1667 17.0436 33.1667 18.75ZM8.5 45.625C8.5 44.5376 9.03678 43.5111 10.0913 42.5379C11.1525 41.5584 12.6702 40.7019 14.4316 39.9962C17.9561 38.5843 22.2047 37.875 25 37.875C27.7953 37.875 32.0439 38.5843 35.5684 39.9962C37.3298 40.7019 38.8475 41.5584 39.9087 42.5379C40.9632 43.5111 41.5 44.5376 41.5 45.625V50C41.5 50.5523 41.0523 51 40.5 51H9.5C8.94772 51 8.5 50.5523 8.5 50V45.625Z",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 18,
    width: 18,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.1665,
    y: 41.667,
    width: 5.83333,
    height: 1.66667,
    rx: 0.833333,
    fill: "#A0CCEF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneDoctor);
export default __webpack_public_path__ + "static/media/oneDoctor.1c35b701f4b06dcf835ffa4a448473a9.svg";
export { ForwardRef as ReactComponent };